import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home  from './pages/Home';
import './App.css';
import AboutMe from './pages/AboutMe';
import Projects from './pages/Projects';
import DetailProject from './pages/DetailProject';
import { AppContextProvider } from './context/AppContext';




function App() {
  
  return (
    <AppContextProvider>
      <BrowserRouter basename='/'>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/about' element={<AboutMe />} />
        <Route path='/projects' element={<Projects/>} />
        <Route path='/projectDetail/:id' element={<DetailProject/>} />
      </Routes>
    </BrowserRouter>
    </AppContextProvider>
  );
}

export default App;
